export enum TaskFilterTypes {
    myself = 'myself',
    company = 'company',
}
